export default class ResetPasswordValidateDto {
	public userId = '';
	public resetToken = '';
	public newPassword = '';

	public constructor(init?: Partial<ResetPasswordValidateDto>) {
        Object.assign(this, init);
    }
}